require([
	'jquery'
], function(
	$
	) {

	'use strict';


	$('.js_footer-menu__up').click(function(){
		$("html, body").animate({scrollTop:0}, 500, 'swing', function() { });
	});


	$('.js_footer-location-link').click(function(){
		if ($('.js_tabs_parent').length >= 1) {

			var currentlocation = window.location.href,
				newLocation = $(this).attr('href');

			if (newLocation === currentlocation) {
				$("html, body").animate({scrollTop:0}, 500, 'swing', function() { });
			} else {
				$("html, body").animate({scrollTop:0}, 10, 'swing', function() { });
				window.location.reload();
			}

		}
	});


});
define("root/Assets/Templates/Html/FullFooter/Js/FullFooter", function(){});

